"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var StorageActions = __importStar(require("../../Actions/Storage"));
var ArrowToRight_1 = require("@styled-icons/boxicons-regular/ArrowToRight");
var ArrowToLeft_1 = require("@styled-icons/boxicons-regular/ArrowToLeft");
var TrashFill_1 = require("@styled-icons/bootstrap/TrashFill");
var initialImageValue = {
  url: null,
  data: {},
  filename: null
};
function ImageUpload(props) {
  var _this = this;
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var onFinished = props.onFinished;
  var _a = react_1.default.useState(initialImageValue),
    image = _a[0],
    setImage = _a[1];
  var beforeUpload = function (file) {
    return __awaiter(_this, void 0, void 0, function () {
      var resp, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            actions.setLoading(true);
            return [4 /*yield*/, StorageActions.getUploadUrlFromFile(file)];
          case 1:
            resp = _a.sent();
            setImage({
              url: resp.url,
              data: resp.fields,
              filename: resp.expected
            });
            return [3 /*break*/, 3];
          case 2:
            err_1 = _a.sent();
            alert('Api error');
            actions.setLoading(false);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  var handleChange = function (info) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (info.file.status === 'uploading') {
          return [2 /*return*/];
        }

        if (info.file.status === 'done') {
          actions.setLoading(false);
          alert("\u6210\u529F! " + image.filename);
          setImage(initialImageValue);
          if (onFinished) {
            onFinished(image.filename);
          }
        }
        return [2 /*return*/];
      });
    });
  };

  return react_1.default.createElement(antd_1.Upload, {
    name: "file",
    showUploadList: false,
    action: image.url,
    beforeUpload: beforeUpload,
    onChange: handleChange,
    data: image.data
  }, react_1.default.createElement(antd_1.Button, null, "\u4E0A\u50B3\u5716\u7247"));
}
function MultiImageUpload(props) {
  var images = props.formData || [];
  var setImages = function (nextImages) {
    props.onChange(nextImages);
  };
  function onFinished(imgUrl) {
    setImages(__spreadArray(__spreadArray([], images), [imgUrl]));
  }
  function moveElement(arr, old_idx, new_idx) {
    arr = __spreadArray([], arr);
    arr.splice(new_idx, 0, arr.splice(old_idx, 1)[0]);
    setImages(arr);
  }
  function deleteElement(arr, idx) {
    arr = __spreadArray([], arr);
    arr.splice(idx, 1);
    setImages(arr);
  }
  return react_1.default.createElement("div", {
    style: {
      margin: '10px 0',
      maxWidth: 800
    }
  }, react_1.default.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, "\u5546\u54C1\u5716\u7247"), react_1.default.createElement(ImageUpload, {
    onFinished: onFinished
  }), react_1.default.createElement("div", {
    style: {
      width: '100%',
      overflowX: 'auto'
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10
    }
  }, Array.isArray(images) && images.map(function (img, idx) {
    return react_1.default.createElement("div", {
      key: idx
    }, react_1.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }
    }, react_1.default.createElement("p", {
      style: {
        backgroundColor: 'orange',
        color: '#fff',
        width: 30,
        height: 30,
        borderRadius: 15,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, idx + 1 + "."), react_1.default.createElement(ArrowToLeft_1.ArrowToLeft, {
      size: 32,
      color: "#6b6b6b",
      style: {
        cursor: 'pointer'
      },
      onClick: function () {
        return moveElement(images, idx, idx - 1);
      }
    }), react_1.default.createElement(ArrowToRight_1.ArrowToRight, {
      size: 32,
      color: "#6b6b6b",
      style: {
        cursor: 'pointer'
      },
      onClick: function () {
        return moveElement(images, idx, idx + 1);
      }
    }), react_1.default.createElement(TrashFill_1.TrashFill, {
      size: 25,
      color: "#ffffff",
      onClick: function () {
        return deleteElement(images, idx);
      },
      style: {
        cursor: 'pointer',
        backgroundColor: '#d40e00',
        padding: 5,
        borderRadius: 5
      }
    })), react_1.default.createElement("img", {
      src: img,
      style: {
        objectFit: 'contain',
        width: 200,
        backgroundColor: '#fff',
        padding: 10
      },
      alt: "product-img"
    }));
  }))));
}
exports.default = MultiImageUpload;